<div class="cb-dot" [ngClass]="['cb-color-' + color(), 'cb-size-' + size()]" [class.cb-outline]="outline()"
  [style]="{'--customColor': customColor()}"></div>